import axios from "axios";
import { createStandaloneToast } from "@chakra-ui/react";
const { toast } = createStandaloneToast();
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 300000,
  headers: { "Content-Type": "application/json" },
});

/* ------------------------ Helpers ------------------------ */
const saveTokens = (access, refresh) => {
  if (access) localStorage.setItem("access_token", access);
  if (refresh) localStorage.setItem("refresh_token", refresh);
};

const logoutUser = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
  localStorage.removeItem("selected_user");

  window.location.href = "/auth/sign-in"; // redirect
};

/* ------------------------ Request Interceptor ------------------------ */
axiosInstance.interceptors.request.use(
  (config) => {
    const access = localStorage.getItem("access_token");

    if (access && access !== "undefined" && access !== "null") {
      config.headers.Authorization = `Bearer ${access}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ---------------------- Response Interceptor ---------------------- */
let refreshPromise = null;

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refresh = localStorage.getItem("refresh_token");

      if (!refresh) {
        logoutUser();
        return Promise.reject(error);
      }

      try {
        if (!refreshPromise) {
          refreshPromise = axios
            .post(
              `${process.env.REACT_APP_API_URL}auth/access/`,
              { refresh_token: refresh },
              { headers: { "Content-Type": "application/json" } }
            )
            .finally(() => {
              refreshPromise = null;
            });
        }

        const res = await refreshPromise;

        const newAccess = res.data?.data?.access_token;
        const newRefresh = res.data?.data?.refresh_token;

        if (!newAccess) {
          logoutUser();
          return Promise.reject(error);
        }

        saveTokens(newAccess, newRefresh ?? refresh);

        originalRequest.headers.Authorization = `Bearer ${newAccess}`;
        return axiosInstance(originalRequest);
      } catch (err) {
        logoutUser();
        return Promise.reject(err);
      }
    }


    // =========================
    // 🔥 HANDLE SPECIFIC ERRORS
    // =========================

    if (error.code === 'ECONNABORTED' || (error.message && error.message.toLowerCase().includes('timeout'))) {
      toast({
        title: "Request Timeout",
        description: "The request exceeded the 5-minute limit.",
        status: "warning",
        duration: 8000,
        isClosable: true,
        position: "top-right",
      });
      return Promise.reject(error);
    }

    const errorMessage = error?.response?.data?.message || "";

    if (errorMessage.includes("Credit limit exceeded")) {
      toast({
        title: "Workspace Credits Exhausted",
        description: errorMessage,
        status: "warning",
        duration: 8000,
        isClosable: true,
        position: "top-right",
      });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
